// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* FrameEditor.css - Dedicated styles for the Frame Annotation Page */

/* Page Layout */
.frame-editor-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  flex-direction: column;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

/* Header */
.frame-editor-header {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 15px 30px;
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.frame-editor-title {
  margin: 0;
  font-size: 1.8em;
  font-weight: 600;
  color: #2c3e50;
  display: flex;
  align-items: center;
  gap: 15px;
}

.frame-editor-title .icon {
  background: linear-gradient(45deg, #667eea, #764ba2);
  padding: 8px;
  border-radius: 8px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-actions {
  display: flex;
  gap: 15px;
  align-items: center;
}

.back-button {
  background: #6c757d;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1em;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.back-button:hover {
  background: #5a6268;
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.save-button {
  background: linear-gradient(45deg, #28a745, #20c997);
  color: white;
  border: none;
  padding: 12px 25px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1em;
  font-weight: 600;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 8px;
}

.save-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);
}

.save-button:disabled {
  background: #6c757d;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* Main Content */
.frame-editor-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding: 30px;
  gap: 25px;
  max-width: none;
  width: 100%;
}

/* Toolbar */
.frame-editor-toolbar {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 20px;
  border-radius: 15px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 25px;
  flex-wrap: wrap;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.toolbar-section {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 15px;
  border-right: 1px solid rgba(0, 0, 0, 0.1);
}

.toolbar-section:last-child {
  border-right: none;
}

.toolbar-section-title {
  font-weight: 600;
  color: #495057;
  font-size: 0.9em;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.tool-group {
  display: flex;
  gap: 8px;
  background: rgba(248, 249, 250, 0.7);
  padding: 8px;
  border-radius: 10px;
}

.tool-button {
  background: white;
  border: 2px solid transparent;
  padding: 12px 18px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9em;
  font-weight: 500;
  transition: all 0.3s ease;
  color: #495057;
  min-width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.tool-button:hover {
  background: #e9ecef;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.tool-button.active {
  background: linear-gradient(45deg, #007bff, #0056b3);
  color: white;
  border-color: #007bff;
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);
}

.tool-button.active:hover {
  background: linear-gradient(45deg, #0056b3, #004085);
}

/* Color Controls */
.color-controls {
  display: flex;
  align-items: center;
  gap: 15px;
}

.color-picker-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
}

.color-picker {
  width: 50px;
  height: 50px;
  border: 3px solid white;
  border-radius: 12px;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.color-picker:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
}

.color-presets {
  display: flex;
  gap: 8px;
}

.color-preset {
  width: 35px;
  height: 35px;
  border-radius: 8px;
  cursor: pointer;
  border: 2px solid white;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.color-preset:hover {
  transform: scale(1.1);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.color-preset.active {
  border-color: #007bff;
  transform: scale(1.15);
}

/* Text Controls */
.text-controls {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Shape Style Controls */
.shape-style-controls {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.style-mode-controls {
  display: flex;
  gap: 15px;
}

.mode-option {
  display: flex;
  align-items: center;
  gap: 6px;
}

.mode-option input[type="radio"] {
  margin: 0;
  width: 16px;
  height: 16px;
  cursor: pointer;
}

.mode-option label {
  font-size: 0.9em;
  font-weight: 500;
  color: #495057;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}

.color-control,
.blur-control {
  display: flex;
  align-items: center;
  gap: 10px;
}

.color-control label,
.blur-control label {
  font-size: 0.85em;
  font-weight: 600;
  color: #495057;
  min-width: 80px;
}

.style-control {
  display: flex;
  align-items: center;
  gap: 8px;
}

.style-control label {
  font-size: 0.85em;
  font-weight: 600;
  color: #495057;
  min-width: 50px;
}

.style-color-picker {
  width: 40px;
  height: 30px;
  border: 2px solid #dee2e6;
  border-radius: 6px;
  cursor: pointer;
  padding: 0;
  background: none;
  transition: all 0.2s ease;
}

.style-color-picker:hover {
  border-color: #007bff;
  transform: scale(1.05);
}

.transparent-button {
  width: 30px;
  height: 30px;
  border: 2px solid #dee2e6;
  border-radius: 6px;
  background: white;
  cursor: pointer;
  font-size: 16px;
  font-weight: bold;
  color: #6c757d;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.transparent-button:hover {
  border-color: #007bff;
  color: #007bff;
}

.transparent-button.active {
  background: #007bff;
  color: white;
  border-color: #007bff;
}

.stroke-width-slider,
.blur-slider {
  width: 80px;
  height: 6px;
  border-radius: 3px;
  background: #dee2e6;
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.stroke-width-slider::-webkit-slider-thumb,
.blur-slider::-webkit-slider-thumb {
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #007bff;
  cursor: pointer;
  border: 2px solid white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.stroke-width-slider::-moz-range-thumb,
.blur-slider::-moz-range-thumb {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #007bff;
  cursor: pointer;
  border: 2px solid white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.stroke-width-slider:hover,
.blur-slider:hover {
  background: #adb5bd;
}

.text-input {
  padding: 10px 15px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.9em;
  width: 180px;
  transition: all 0.3s ease;
  background: white;
}

.text-input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
}

.font-size-input {
  padding: 8px 12px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 0.9em;
  width: 80px;
  text-align: center;
}

/* Action Controls */
.action-controls {
  display: flex;
  gap: 10px;
}

.action-button {
  background: white;
  border: 2px solid #dee2e6;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.9em;
  font-weight: 500;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 6px;
}

.action-button:hover:not(:disabled) {
  background: #f8f9fa;
  border-color: #adb5bd;
  transform: translateY(-1px);
}

.action-button:disabled {
  background: #e9ecef;
  color: #6c757d;
  cursor: not-allowed;
  transform: none;
}

.action-button.danger {
  border-color: #dc3545;
  color: #dc3545;
}

.action-button.danger:hover:not(:disabled) {
  background: #dc3545;
  color: white;
}

.action-button.success {
  border-color: #28a745;
  color: #28a745;
}

.action-button.success:hover:not(:disabled) {
  background: #28a745;
  color: white;
}

/* Canvas Container */
.canvas-container {
  flex: 1 1;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 30px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.2);
  min-height: 500px;
  overflow: visible;
  /* Ensure no width constraints */
  width: 100%;
  height: 100%;
  max-width: none;
  /* Center the canvas */
  flex-direction: column;
  /* Ensure content isn't clipped */
  position: relative;
}

.canvas-wrapper {
  position: relative;
  overflow: visible;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
  background: white;
  transition: transform 0.2s ease;
  /* Ensure wrapper doesn't constrain dimensions */
  display: block;
  max-width: none;
  max-height: none;
  width: auto;
  height: auto;
  /* Center the canvas within its wrapper */
  margin: 0 auto;
  /* Remove any potential clipping */
  border-radius: 0;
}

/* Canvas Controls */
.canvas-controls {
  display: flex;
  align-items: center;
  gap: 15px;
}

.canvas-size-inputs {
  display: flex;
  align-items: center;
  gap: 8px;
}

.canvas-size-inputs label {
  font-size: 0.9em;
  font-weight: 600;
  color: #495057;
}

.canvas-size-input {
  width: 80px;
  padding: 6px 10px;
  border: 2px solid #e9ecef;
  border-radius: 6px;
  font-size: 0.9em;
  text-align: center;
  transition: all 0.3s ease;
}

.canvas-size-input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);
}

.reset-size-button {
  background: linear-gradient(45deg, #6c757d, #5a6268);
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 0.9em;
  font-weight: 500;
  transition: all 0.3s ease;
}

.reset-size-button:hover {
  background: linear-gradient(45deg, #5a6268, #495057);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

/* Loading States */
.loading-canvas {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  color: #6c757d;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid #e9ecef;
  border-top: 4px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Layer Controls */
.layer-controls {
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 200px;
}

.layer-controls h4 {
  margin: 0 0 10px 0;
  font-size: 0.9em;
  color: #495057;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.layer-item {
  padding: 8px 12px;
  background: white;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.8em;
}

.layer-item:hover {
  background: #f8f9fa;
  border-color: #adb5bd;
}

.layer-item.selected {
  background: #007bff;
  color: white;
  border-color: #007bff;
}

/* Status Bar */
.status-bar {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 15px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  font-size: 0.9em;
  color: #6c757d;
}

.status-info {
  display: flex;
  gap: 20px;
}

.zoom-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

.zoom-button {
  background: white;
  border: 1px solid #dee2e6;
  padding: 6px 12px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.zoom-button:hover {
  background: #f8f9fa;
  border-color: #adb5bd;
}

/* Responsive Design */
@media (max-width: 1200px) {
  .frame-editor-toolbar {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
  }
  
  .toolbar-section {
    border-right: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding-bottom: 15px;
  }
  
  .toolbar-section:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
}

@media (max-width: 768px) {
  .frame-editor-main {
    padding: 15px;
  }
  
  .frame-editor-header {
    padding: 10px 15px;
    flex-direction: column;
    gap: 15px;
  }
  
  .frame-editor-title {
    font-size: 1.4em;
  }
  
  .header-actions {
    width: 100%;
    justify-content: space-between;
  }
  
  .canvas-container {
    padding: 15px;
  }
  
  .layer-controls {
    position: static;
    margin-top: 15px;
  }
}

/* Animations */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.frame-editor-page > * {
  animation: fadeIn 0.6s ease-out;
}

/* Tooltips */
.tooltip {
  position: relative;
}

.tooltip::after {
  content: attr(data-tooltip);
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 0.8em;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
  margin-bottom: 5px;
}

.tooltip:hover::after {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/FrameEditor.css"],"names":[],"mappings":"AAAA,qEAAqE;;AAErE,gBAAgB;AAChB;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,sBAAsB;EACtB,4DAA4D;AAC9D;;AAEA,WAAW;AACX;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,oCAAoC;EACpC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,oDAAoD;AACtD;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,qBAAqB;AACrB;EACE,SAAO;EACP,qCAAqC;EACrC,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;EAC1C,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,0CAA0C;EAC1C,iBAAiB;EACjB,+BAA+B;EAC/B,gDAAgD;EAChD,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,cAAc;EACd,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,qCAAqC;EACrC,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,2CAA2C;IAC3C,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA,eAAe;AACf;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA,aAAa;AACb;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ","sourcesContent":["/* FrameEditor.css - Dedicated styles for the Frame Annotation Page */\n\n/* Page Layout */\n.frame-editor-page {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  display: flex;\n  flex-direction: column;\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n}\n\n/* Header */\n.frame-editor-header {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  padding: 15px 30px;\n  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.frame-editor-title {\n  margin: 0;\n  font-size: 1.8em;\n  font-weight: 600;\n  color: #2c3e50;\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.frame-editor-title .icon {\n  background: linear-gradient(45deg, #667eea, #764ba2);\n  padding: 8px;\n  border-radius: 8px;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.header-actions {\n  display: flex;\n  gap: 15px;\n  align-items: center;\n}\n\n.back-button {\n  background: #6c757d;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1em;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.back-button:hover {\n  background: #5a6268;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n.save-button {\n  background: linear-gradient(45deg, #28a745, #20c997);\n  color: white;\n  border: none;\n  padding: 12px 25px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1em;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.save-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(40, 167, 69, 0.4);\n}\n\n.save-button:disabled {\n  background: #6c757d;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n/* Main Content */\n.frame-editor-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  padding: 30px;\n  gap: 25px;\n  max-width: none;\n  width: 100%;\n}\n\n/* Toolbar */\n.frame-editor-toolbar {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  padding: 20px;\n  border-radius: 15px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  gap: 25px;\n  flex-wrap: wrap;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.toolbar-section {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 0 15px;\n  border-right: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.toolbar-section:last-child {\n  border-right: none;\n}\n\n.toolbar-section-title {\n  font-weight: 600;\n  color: #495057;\n  font-size: 0.9em;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.tool-group {\n  display: flex;\n  gap: 8px;\n  background: rgba(248, 249, 250, 0.7);\n  padding: 8px;\n  border-radius: 10px;\n}\n\n.tool-button {\n  background: white;\n  border: 2px solid transparent;\n  padding: 12px 18px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.9em;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  color: #495057;\n  min-width: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.tool-button:hover {\n  background: #e9ecef;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n.tool-button.active {\n  background: linear-gradient(45deg, #007bff, #0056b3);\n  color: white;\n  border-color: #007bff;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(0, 123, 255, 0.4);\n}\n\n.tool-button.active:hover {\n  background: linear-gradient(45deg, #0056b3, #004085);\n}\n\n/* Color Controls */\n.color-controls {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.color-picker-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.color-picker {\n  width: 50px;\n  height: 50px;\n  border: 3px solid white;\n  border-radius: 12px;\n  cursor: pointer;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n  transition: all 0.3s ease;\n}\n\n.color-picker:hover {\n  transform: scale(1.1);\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);\n}\n\n.color-presets {\n  display: flex;\n  gap: 8px;\n}\n\n.color-preset {\n  width: 35px;\n  height: 35px;\n  border-radius: 8px;\n  cursor: pointer;\n  border: 2px solid white;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.color-preset:hover {\n  transform: scale(1.1);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);\n}\n\n.color-preset.active {\n  border-color: #007bff;\n  transform: scale(1.15);\n}\n\n/* Text Controls */\n.text-controls {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* Shape Style Controls */\n.shape-style-controls {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.style-mode-controls {\n  display: flex;\n  gap: 15px;\n}\n\n.mode-option {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.mode-option input[type=\"radio\"] {\n  margin: 0;\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n}\n\n.mode-option label {\n  font-size: 0.9em;\n  font-weight: 500;\n  color: #495057;\n  cursor: pointer;\n  user-select: none;\n}\n\n.color-control,\n.blur-control {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.color-control label,\n.blur-control label {\n  font-size: 0.85em;\n  font-weight: 600;\n  color: #495057;\n  min-width: 80px;\n}\n\n.style-control {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.style-control label {\n  font-size: 0.85em;\n  font-weight: 600;\n  color: #495057;\n  min-width: 50px;\n}\n\n.style-color-picker {\n  width: 40px;\n  height: 30px;\n  border: 2px solid #dee2e6;\n  border-radius: 6px;\n  cursor: pointer;\n  padding: 0;\n  background: none;\n  transition: all 0.2s ease;\n}\n\n.style-color-picker:hover {\n  border-color: #007bff;\n  transform: scale(1.05);\n}\n\n.transparent-button {\n  width: 30px;\n  height: 30px;\n  border: 2px solid #dee2e6;\n  border-radius: 6px;\n  background: white;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: bold;\n  color: #6c757d;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.transparent-button:hover {\n  border-color: #007bff;\n  color: #007bff;\n}\n\n.transparent-button.active {\n  background: #007bff;\n  color: white;\n  border-color: #007bff;\n}\n\n.stroke-width-slider,\n.blur-slider {\n  width: 80px;\n  height: 6px;\n  border-radius: 3px;\n  background: #dee2e6;\n  outline: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.stroke-width-slider::-webkit-slider-thumb,\n.blur-slider::-webkit-slider-thumb {\n  appearance: none;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #007bff;\n  cursor: pointer;\n  border: 2px solid white;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n}\n\n.stroke-width-slider::-moz-range-thumb,\n.blur-slider::-moz-range-thumb {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #007bff;\n  cursor: pointer;\n  border: 2px solid white;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\n}\n\n.stroke-width-slider:hover,\n.blur-slider:hover {\n  background: #adb5bd;\n}\n\n.text-input {\n  padding: 10px 15px;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  font-size: 0.9em;\n  width: 180px;\n  transition: all 0.3s ease;\n  background: white;\n}\n\n.text-input:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);\n}\n\n.font-size-input {\n  padding: 8px 12px;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  font-size: 0.9em;\n  width: 80px;\n  text-align: center;\n}\n\n/* Action Controls */\n.action-controls {\n  display: flex;\n  gap: 10px;\n}\n\n.action-button {\n  background: white;\n  border: 2px solid #dee2e6;\n  padding: 10px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.9em;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.action-button:hover:not(:disabled) {\n  background: #f8f9fa;\n  border-color: #adb5bd;\n  transform: translateY(-1px);\n}\n\n.action-button:disabled {\n  background: #e9ecef;\n  color: #6c757d;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.action-button.danger {\n  border-color: #dc3545;\n  color: #dc3545;\n}\n\n.action-button.danger:hover:not(:disabled) {\n  background: #dc3545;\n  color: white;\n}\n\n.action-button.success {\n  border-color: #28a745;\n  color: #28a745;\n}\n\n.action-button.success:hover:not(:disabled) {\n  background: #28a745;\n  color: white;\n}\n\n/* Canvas Container */\n.canvas-container {\n  flex: 1;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  border-radius: 15px;\n  padding: 30px;\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  min-height: 500px;\n  overflow: visible;\n  /* Ensure no width constraints */\n  width: 100%;\n  height: 100%;\n  max-width: none;\n  /* Center the canvas */\n  flex-direction: column;\n  /* Ensure content isn't clipped */\n  position: relative;\n}\n\n.canvas-wrapper {\n  position: relative;\n  overflow: visible;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);\n  background: white;\n  transition: transform 0.2s ease;\n  /* Ensure wrapper doesn't constrain dimensions */\n  display: block;\n  max-width: none;\n  max-height: none;\n  width: auto;\n  height: auto;\n  /* Center the canvas within its wrapper */\n  margin: 0 auto;\n  /* Remove any potential clipping */\n  border-radius: 0;\n}\n\n/* Canvas Controls */\n.canvas-controls {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n}\n\n.canvas-size-inputs {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.canvas-size-inputs label {\n  font-size: 0.9em;\n  font-weight: 600;\n  color: #495057;\n}\n\n.canvas-size-input {\n  width: 80px;\n  padding: 6px 10px;\n  border: 2px solid #e9ecef;\n  border-radius: 6px;\n  font-size: 0.9em;\n  text-align: center;\n  transition: all 0.3s ease;\n}\n\n.canvas-size-input:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.1);\n}\n\n.reset-size-button {\n  background: linear-gradient(45deg, #6c757d, #5a6268);\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 0.9em;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.reset-size-button:hover {\n  background: linear-gradient(45deg, #5a6268, #495057);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n/* Loading States */\n.loading-canvas {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  color: #6c757d;\n}\n\n.loading-spinner {\n  width: 50px;\n  height: 50px;\n  border: 4px solid #e9ecef;\n  border-top: 4px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Layer Controls */\n.layer-controls {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  padding: 15px;\n  border-radius: 10px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: 200px;\n}\n\n.layer-controls h4 {\n  margin: 0 0 10px 0;\n  font-size: 0.9em;\n  color: #495057;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.layer-item {\n  padding: 8px 12px;\n  background: white;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.8em;\n}\n\n.layer-item:hover {\n  background: #f8f9fa;\n  border-color: #adb5bd;\n}\n\n.layer-item.selected {\n  background: #007bff;\n  color: white;\n  border-color: #007bff;\n}\n\n/* Status Bar */\n.status-bar {\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  padding: 15px 30px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  font-size: 0.9em;\n  color: #6c757d;\n}\n\n.status-info {\n  display: flex;\n  gap: 20px;\n}\n\n.zoom-controls {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.zoom-button {\n  background: white;\n  border: 1px solid #dee2e6;\n  padding: 6px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.zoom-button:hover {\n  background: #f8f9fa;\n  border-color: #adb5bd;\n}\n\n/* Responsive Design */\n@media (max-width: 1200px) {\n  .frame-editor-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 15px;\n  }\n  \n  .toolbar-section {\n    border-right: none;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n    padding-bottom: 15px;\n  }\n  \n  .toolbar-section:last-child {\n    border-bottom: none;\n    padding-bottom: 0;\n  }\n}\n\n@media (max-width: 768px) {\n  .frame-editor-main {\n    padding: 15px;\n  }\n  \n  .frame-editor-header {\n    padding: 10px 15px;\n    flex-direction: column;\n    gap: 15px;\n  }\n  \n  .frame-editor-title {\n    font-size: 1.4em;\n  }\n  \n  .header-actions {\n    width: 100%;\n    justify-content: space-between;\n  }\n  \n  .canvas-container {\n    padding: 15px;\n  }\n  \n  .layer-controls {\n    position: static;\n    margin-top: 15px;\n  }\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.frame-editor-page > * {\n  animation: fadeIn 0.6s ease-out;\n}\n\n/* Tooltips */\n.tooltip {\n  position: relative;\n}\n\n.tooltip::after {\n  content: attr(data-tooltip);\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(0, 0, 0, 0.8);\n  color: white;\n  padding: 6px 10px;\n  border-radius: 6px;\n  font-size: 0.8em;\n  white-space: nowrap;\n  opacity: 0;\n  pointer-events: none;\n  transition: opacity 0.3s ease;\n  margin-bottom: 5px;\n}\n\n.tooltip:hover::after {\n  opacity: 1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
